/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, { createContext, useContext } from 'react'
import { TableInitBase } from 'utils/hooks/useTable'
import { TableViewId } from 'types/enums/specific/TableViewId'

interface TableViewDropdownContextValue {
    tableInit: TableInitBase
}

const TableViewDropdownContext = createContext<TableViewDropdownContextValue | null>(null)

export const isTableViewId = (tableId: string): tableId is TableViewId =>
    Object.values(TableViewId).includes(tableId as TableViewId)

export const resolveTableViewId = (tableId?: string): TableViewId | undefined =>
    tableId && isTableViewId(tableId) ? tableId : undefined

interface TableViewDropdownProviderProps {
    tableInit: TableInitBase
    children: React.ReactNode
}

export const TableViewDropdownProvider: React.FC<TableViewDropdownProviderProps> = ({ tableInit, children }) => (
    <TableViewDropdownContext.Provider value={{ tableInit }}>{children}</TableViewDropdownContext.Provider>
)

export const useTableViewDropdownContext = (): TableViewDropdownContextValue | null =>
    useContext(TableViewDropdownContext)
